module.exports = __webpack_public_path__ + "static/media/pov_whole_Dodecahedron.c7e0ca00.png";